module.exports = __webpack_public_path__ + "svg/aquarius.svg?43eeb318b49455f4d7e261140ffaef95";